const addDialog = (state, { payload }) => {
    state.dialogs[payload] = {
        open: false,
        data: {}
    };
};

export default addDialog;
